<p>
  Ако желаете да прекратите използването на платформата и да изтриете своя профил, може да го направите самостоятелно
  от менюто с настройки. Имайте предвид, че процесът е <strong>необратим</strong>, а всички, свързани с акаунта ви,
  данни ще бъдат <strong>постоянно изтрити</strong>.
</p>
<h6 class="mt-3">Стъпки за изтриване на профила:</h6>
<ol>
  <li>Отидете в <strong>„Профил“</strong> → <strong>„Настройки“</strong>.</li>
  <li>Превъртете до секцията <strong>„Изтриване на профила“</strong>.</li>
  <li>Натиснете бутона <strong>„Изтрий“</strong>, отбелязан в червено.</li>
  <li>Въведете паролата си за потвърждение на самоличността.</li>
  <li>Потвърдете, че желаете окончателно да изтриете профила си.</li>
</ol>
<h6 class="mt-3">Какво се изтрива при изтриване на профила?</h6>
<p>След потвърждение профилът ви ще бъде изтрит за постоянно. Това включва:</p>
<ul>
  <li>лични данни (име, имейл, адрес и др.);</li>
  <li>всички, публикувани от вас обяви;</li>
  <li>история на покупки и продажби;</li>
  <li>съобщения, коментари и отзиви, свързани с акаунта;</li>
  <li>предпочитания и настройки на известията.</li>
</ul>
<div class="alert alert-danger">
  <strong>Важно:</strong> След изтриване на профила <strong>няма да може да го възстановите</strong>.
</div>
<div class="alert alert-primary m-0">
  <strong>Нужда от съдействие?</strong> Ако имате въпроси или затруднения, свържете се с нас чрез
  <a class="text-decoration-none" [routerLink]="[appRoutes.root, appRoutes.contactUs]">формата за контакт.</a>
</div>
